import { useOutletContext } from "react-router-dom";
import type { CurrentUser } from "../api/types";

export interface OutletCtx {
  user: CurrentUser;
}

export function useCurrentUser(): CurrentUser {
  return useOutletContext<OutletCtx>().user;
}
